import { Pipe, PipeTransform } from '@angular/core'
import { GapNightAutomation } from '@tokeet-frontend/rate-automations'
import * as lodash from 'lodash'

@Pipe({
  name: 'gapNightDec',
})
export class GapNightDecPipe implements PipeTransform {
  transform(item: GapNightAutomation): string {
    return lodash
      .chain(item.gaps)
      .map((t) => {
        const adjs = []
        adjs.push($localize`Gap Nights: ` + t.gaps_required)
        if (!lodash.isNil(t.min_nights)) {
          adjs.push($localize`Min Nights: ` + this.getMinNights(t.min_nights))
        }
        adjs.push($localize`Adjustment: ` + (t.adjust_abs || `${t.adjust_pct}%`))
        return adjs.join(', ') + '.'
      })
      .join(', ')
      .value()
  }

  getMinNights(min: any) {
    if (lodash.isNil(min)) return ''
    min = String(min)
    if (min.startsWith('g')) {
      return $localize`Length of gap` + (min.length === 1 ? '' : ` - ${min.slice(1)}`)
    } else {
      return min
    }
  }
}
